import { addDoc, collection, doc, serverTimestamp, updateDoc } from "firebase/firestore"
import { db } from "../../../firebase/config"
import { message } from "antd"

export const SplitOrderFunction = async (
  orderData,
  firstOrderLabelCount,
  secondOrderLabelCount,
  comment,
  user
) => {
  //old order object
  const oldOrderObject = orderData

  //creates aa copy without the id
  const { id, ...copyOfOrder } = oldOrderObject

  //old order ref
  const oldOrderRef = doc(db, "orders", oldOrderObject.id)

  //new order object
  const newOrderObject = {
    ...copyOfOrder,
    labelCount: firstOrderLabelCount,
    splitTime: serverTimestamp(),
    splitOrder: true,
    otherOrderId: oldOrderObject.id,
    machineOrderSplitComment: comment,
    splitMachinePrinter: user.uid,
    splitMachinePrinterEmail: user.email,
    beforeSplitLabelCount: oldOrderObject.labelCount,
    partOfSplit: 1,
    totalParts: 2,
  }

  try {
    //creates a new doc with same params with new id
    const newDoc = await addDoc(collection(db, "orders"), newOrderObject)
    console.log("Document written with ID: ", newDoc.id)

    // Update the old order with properties for the second order after the split
    await updateDoc(oldOrderRef, {
      splitTime: serverTimestamp(),
      splitOrder: true,
      labelCount: secondOrderLabelCount,
      otherOrderId: newDoc.id,
      machineOrderSplitComment: comment,
      splitMachinePrinter: user.uid,
      splitMachinePrinterEmail: user.email,
      beforeSplitLabelCount: oldOrderObject.labelCount,
      partOfSplit: 2,
      totalParts: 2,
    })

    //preparing the array of the new order id's for the roll update
    const newAssignedOrderList = [newDoc.id, oldOrderObject.id]

    // Update roll assignments for rolls assigned to the first order after the split
    for (const roll of orderData.assignedRollIds) {
      const rollRef = doc(db, "rolls", roll)
      try {
        await updateDoc(rollRef, {
          assignedOrderId: newAssignedOrderList,
        })
      } catch (error) {
        message.error("error while updating roll")
        console.log(error)
      }
      console.log("ids", roll)
      console.log("new array", newAssignedOrderList)
    }
  } catch (error) {
    console.log("Entering catch block")
    message.error("Error happened! Check logs")
    console.log(error.message)
  } finally {
    message.success("Order split!")
  }
}
